import { EventEmitter } from '@angular/core';
import { ModalService } from '@ibe/services/ui';
import { INDRALoginModalComponent } from '@ibe.components/shared/login-modal/login-modal.indra.component';
import { combineLatest } from 'rxjs';
import { takeWhile } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import * as fromStore from '@ibe/store/index';
import * as _ from 'lodash';
import { INDRAStorageService } from '@ibe.services/storage.indra.service';
import { ActivatedRoute } from '@angular/router';
import { INDRAAncillariesSelectionService } from '@ibe.services/ancillaries-selection.indra.service';
var INDRAExtrasSidebarMilesInfoComponent = /** @class */ (function () {
    function INDRAExtrasSidebarMilesInfoComponent(store, modalService, storageService, route, ancillariesSelectionSrv) {
        var _this = this;
        this.store = store;
        this.modalService = modalService;
        this.storageService = storageService;
        this.route = route;
        this.ancillariesSelectionSrv = ancillariesSelectionSrv;
        this.payExtrasWithMiles = false;
        this.notEnoughMilesFlag = true;
        this.isChecked = new EventEmitter();
        // Corp (note: from post-sprint 8 client code merge)
        // isCorporate$: Observable<boolean> = this.store.select(fromStore.getIsCorporate);
        // isCorporate: boolean;
        // promoname: string;
        // promotype: string;
        // User info
        this.user$ = this.store.select(fromStore.getUserInfo);
        this.bookedTrip$ = this.store.select(fromStore.getSelectedBookedTrip);
        this.milesSpent$ = this.store.select(fromStore.getTotalMilesToSpend);
        this.hasChanges$ = combineLatest([this.user$, this.milesSpent$]);
        this.hasExtras = false;
        this.hasLoggin = false;
        this.userMiles = 0;
        // milesNeeded = 0;
        // promoCoin: string;
        // payExtrasWithMiles: boolean = false;
        this.isAlive = true;
        this.ancillary$ = this.store.select(fromStore.getAncillaryToPayWithMiles);
        this.milesSpent = 0;
        this.payExtrasWithMilesStatus = false;
        this.prevPayWithMilesFlightList = [];
        this.ancType = this.storageService.get('ancType');
        this.route.queryParams.subscribe(function (params) {
            _this.flightID = params['flight'];
        });
        this.hasChanges$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (_a) {
            var value = _a[0], milesSpent = _a[1];
            if (value) {
                _this.milesSpent = milesSpent;
                _this.hasLoggin = true;
                _this.userMiles = parseInt(value.currentPoints, 10) - _this.milesSpent;
            }
            else
                _this.hasLoggin = false;
        });
        /* note: from post-sprint 8 client code merge
        this.isCorporate$.pipe(takeWhile(() => this.isAlive))
            .subscribe(value => {
                this.isCorporate = value;
                if (value === true) {
                    this.promotype = 'balance';
                    this.promoCoin = '€';
                } else {
                    this.promotype = 'miles';
                    this.promoCoin = 'M';
                }
            });
        */
        /* this.ancillary$.pipe(takeWhile(() => this.isAlive))
            .subscribe((value) => {
                if (value) {
                    this.ancillary = this.payAncillariesWithMilesService.getMilesToPayAncillary(value, this.promotype);
                }
                if (this.ancillary) {
                    this.milesNeeded = this.ancillary.total;
                    this.hasExtras = this.ancillary.count !== 0;
                } else {
                    this.milesNeeded = 0;
                    this.hasExtras = true;
                }
            }); */
        this.prevPayWithMilesFlightList = _.cloneDeep(this.ancillariesSelectionSrv.payWithMilesFlightList);
        this.storageService.set('prevPayWithMilesFlightList', this.prevPayWithMilesFlightList);
    }
    INDRAExtrasSidebarMilesInfoComponent.prototype.ngOnInit = function () {
        if (this.payExtrasWithMiles && this.hasAddedExtrasFlag) {
            var isChecked = this.payExtrasWithMiles && this.hasAddedExtrasFlag;
            this.ancillariesSelectionSrv.INDRA_getPayWithMilesByFlightId(this.flightID, isChecked, this.ancType);
        }
        this.payExtrasWithMilesStatus = this.ancillariesSelectionSrv.INDRA_getFlightPayWithMilesStatus(this.flightID, this.ancType) || (this.payExtrasWithMiles && this.hasAddedExtrasFlag);
        this.isChecked.emit(this.payExtrasWithMilesStatus);
        sessionStorage.setItem("is" + this.ancType + "withMiles", JSON.stringify(this.payExtrasWithMilesStatus));
    };
    INDRAExtrasSidebarMilesInfoComponent.prototype.INDRA_handleLogin = function () {
        this.modalService.assignComponent(INDRALoginModalComponent);
        this.modalService.open();
    };
    INDRAExtrasSidebarMilesInfoComponent.prototype.INDRA_useMilesChange = function (event) {
        // this.payExtrasWithMiles = event.target.checked;
        this.ancillariesSelectionSrv.INDRA_getPayWithMilesByFlightId(this.flightID, event.target.checked, this.ancType);
        this.payExtrasWithMilesStatus = this.ancillariesSelectionSrv.INDRA_getFlightPayWithMilesStatus(this.flightID, this.ancType) || (this.payExtrasWithMiles && this.hasAddedExtrasFlag);
        sessionStorage.setItem("is" + this.ancType + "withMiles", JSON.stringify(event.target.checked));
        this.isChecked.emit(this.payExtrasWithMilesStatus);
    };
    INDRAExtrasSidebarMilesInfoComponent.prototype.INDRA_hasAddedExtras = function () {
        return this.hasAddedExtrasFlag;
        // if (this.addedAncillary) {
        // 	if (this.addedAncillary.length != 0) {
        // 		return true;
        // 	}
        // }
        // return false;
    };
    return INDRAExtrasSidebarMilesInfoComponent;
}());
export { INDRAExtrasSidebarMilesInfoComponent };
